// import { register } from '../../module/Register/locale/register.en.js';
import { example } from '@/module/Example/locale/example.en';
// base
import { date } from '@/helper/locale/base/base_date.en.js';
import { button } from '@/helper/locale/base/base_button.en.js';
// module
import { collect_point } from '@/module/CollectPoint/locale/collectpoint.en.js';
import { home } from '@/module/Home/locale/home.en.js';
import { profile } from '@/module/Profile/locale/profile.en.js';
import { mission } from '@/module/Mission/locale/mission.en.js';
import { financial_health } from '@/module/FinancialHealth/locale/financial_health.th.js'; // เข้ามา en หน้านี้จะแสดงไทยหมด!

export const en = {
    example: example,
    // base
    date: date,
    button: button,
    // module
    collect_point: collect_point,

    home: home,
    profile: profile,
    mission: mission,
    financial_health: financial_health,

    confirm_redeem: {
        confirm: "Confirm",
        cancel: "Cancel",

        headline: 'Confirm',
        default: 'Confirm to redeem',
        defualt_have_time: 'Serial will available for {0} after confirm',
        delivery: 'Please enter shipping information to redeem',
        free: 'Serial will available for {0} after confirm',
        free_no_timer: 'Confirm to redeem',
        free_delivery: 'Please enter shipping information to redeem',
        draw: 'Confirm to join campaign <br/> Winner will be announced after {0}',
        draw_delivery: 'Please enter shipping information to redeem',
        deal: 'Serial will available for {0} after confirm',
        deal_no_timer: 'Confirm to redeem',
        deal_delivery: 'Please enter shipping information to redeem',
        buy: 'Confirm to purchase',
        buy_delivery: 'Please enter shipping information to buy',
        interface: 'Confirm to redeem',

        msg_free_deal: 'Redeem {0} planktons<br>to get this reward?',
        msg_interface: 'Redeem {0} planktons<br>to get this reward?',
    },
    redeem_button: {
        default: 'Redeem',
        none: '',
        soldOut: 'This reward has been fully redeemed.',
        soldOutBuy: 'This reward has been fully redeemed.',
        maxPerPerson: 'You have already redeemed this reward.',
        redeemCoolDown: 'You have already redeemed this reward. Please wait to redeem again later.',
        nextDate: '<br/>at : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'This campaign requires your action before redemption, please review the conditions first.',
        campaignExpired: 'This reward has expired.',
        campaignExpiredBuy: 'This reward has expired.',
        campaignNotAvailable: 'Sorry. This reward is not available',
        campaignNotAvailableBuy: 'Sorry. This product is not available',
        notEnoughPoint: "You don't have enough planktons to redeem",
        notSupport: 'This campaign is not support.'
    },
    purchase: {
        show_code: 'view code',
        code_expired: 'Expired',
        code_used: 'Used',

        delivery: 'To receive',
        shipped: 'Delivered',
        parcel_no: 'Tracking number',

        not_draw1: 'Not yet drawn,',
        not_draw2: 'please check back at a later date',
        draw_winner1: 'You are the winner',
        draw_winner2: '',
        draw_not_win1: 'Sorry you are not the winner,',
        draw_not_win2: 'better luck next',

        status: 'Status : ',
        used_coupon: 'View Coupon',
        use_date: 'Expiring date',

        status_process: {
            prepare: 'To ship',
            on_delivery: 'To delivery',
            delivery: 'To receive',
            success: 'Completed',
        }
    },
    serial: {
        close_btn: 'Close',
        default_privilege_message: 'As design',
        show_code_at_shop: 'Please show code below to claim your privilege',
        title_for_staff: 'For merchant only',
        btn_for_staff: 'For staff',

        // delivery: 'Product will be mailed based on Campaign Condition.',
        delivery: {
            title: 'Redemption successful',
            msg: 'The parcel will be delivered within 3-5 working days',
            btn_coupon: 'View my rewards',
            btn_close: 'Close'
        },

        draw: 'Thank you for joining us.<br/>Winner will be announced after {0}',
        draw_after: 'after',

        qr_code: 'QR code',
        barcode: 'Barcode',
        code: 'Code',

        copy_code: 'Copy code',
        copy_success: 'Copied',

        expire_in: 'Expired : ',
        minute: '',
        code_expired: 'This serial has expired.',
        date_redeem: 'Redemption date :',

        redeem_on: 'Redeem on {0}',

        detail: 'Rewards details',
        btn_coupon: 'View my rewards',
        btn_close: 'Close',
        camp_expire: 'Rewards expired',
        camp_used: 'Used',
    },
    shipping: {
        headline: 'Delivery address',
        info_warning: 'Customers must fill in the delivery details themselves and consent to the Bank sending their delivery information to a 3rd party company.',

        firstname: {
            name: 'Name',
            placeholder: 'Please enter your name',
            required: 'Please enter your name',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'Last name',
            placeholder: 'Please enter your last name',
            required: 'Please enter your last name',
            too_short: '',
            invalid: '',
        },
        addressName: {
            name: 'Address name',
            placeholder: 'Address name',
            required: 'Please enter address name',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'Details',
            placeholder: 'Please enter your address',
            required: 'Please enter your address',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'Mobile number',
            placeholder: 'Please enter your mobile number',
            required: 'Please enter your mobile number',
            too_short: 'Contact number must be {0} digits',
            invalid: 'Incorrect contact number format',
        },
        nationalid: {
            name: 'National id',
            placeholder: 'National id',
            required: 'Please enter national id',
            too_short: 'National id number must be {0} digits',
            invalid: 'Incorrect national id format',
        },
        email: {
            name: 'Email',
            placeholder: 'Email',
            required: 'Please enter email address',
            too_short: '',
            invalid: 'Incorrect email format',
        },
        zipcode: {
            name: 'Postcode',
            placeholder: 'Please enter your postcode',
            required: 'Please enter your postcode',
            too_short: 'Zipcode must be {0} digits',
            invalid: 'Invalid zipcode',
        },
        subdistrict: {
            name: 'Sub-district',
            placeholder: 'Please select sub-district',
            required: 'Please select sub-district',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'District',
            placeholder: 'Please select district',
            required: 'Please select district',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'Province',
            placeholder: 'Please select your province',
            required: 'Please select your province',
            too_short: '',
            invalid: '',
        },

        isDefaultAddress: 'Save this address',
        defaultAddress: 'Default',
        save_address: 'Save address for next privilege',
        save_address_buy: 'Save address for next puchase',

        confirm_btn: 'Confirm',
        cancel_btn: 'Cancel',

        alert_headline: 'Shipping address',
        alert_ok_btn: 'OK',

        modal_confirm: {
            title: 'Please check the information',
            msg: 'Confirm the information',
            btn_edit: 'Edit',
        }
    },
    tax: {
        personType: {
            name: 'ออกในนาม',
            placeholder: '',
            required: 'กรุณาเลือก',
            too_short: '',
            invalid: '',
        },
        title: {
            name: 'คำนำหน้าชื่อ',
            placeholder: '',
            required: 'กรุณาเลือก',
            too_short: '',
            invalid: '',
        },
        companyName: {
            name: 'ชื่อ / บริษัท',
            placeholder: 'ชื่อ / บริษัท',
            required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            too_short: '',
            invalid: '',
        },
        building: {
            name: 'อาคาร',
            placeholder: 'อาคาร',
            required: '',
            too_short: '',
            invalid: '',
        },
        room: {
            name: 'เลขที่ห้อง',
            placeholder: 'เลขที่ห้อง',
            required: '',
            too_short: '',
            invalid: '',
        },
        floor: {
            name: 'ชั้นที่',
            placeholder: 'ชั้นที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        village: {
            name: 'หมู่บ้าน',
            placeholder: 'หมู่บ้าน',
            required: '',
            too_short: '',
            invalid: '',
        },
        number: {
            name: 'เลขที่',
            placeholder: 'เลขที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        moo: {
            name: 'หมู่ที่',
            placeholder: 'หมู่ที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        soi: {
            name: 'ซอย',
            placeholder: 'ซอย',
            required: '',
            too_short: '',
            invalid: '',
        },
        road: {
            name: 'ถนน',
            placeholder: 'ถนน',
            required: '',
            too_short: '',
            invalid: '',
        },
    },
    main: {
        home_page: "Home",
        login: "Login",
        campaign: "Campaign",
        category: 'Category',
        map: "Map",
        terms: "Terms And Conditions",
        history: 'History',
        profile: "Profile",
        logout: "Logout",
        lang: "Language",
        msgLogout: "Logout ?",
        cancel: "Cancel",
    },
    campaign: {
        point: 'plankton',
        get_point: 'Get Point : ',
        use_point: 'Redeem ',
    },
    detail: {
        detail: 'Details',
        condition: 'Conditions',

        point_unit: 'plankton',
        get_point: 'Get Point : ',
        use_point: 'Redeem ',
        available_date: 'Date',
        expire_date: 'Expire date : {0}',

        color: {
            name: 'Color',
            placeholder: 'Please select color',
            required: 'Please select color',
        },
        size: {
            name: 'Size',
            placeholder: 'Please select size',
            required: 'Please select size',
        },

        verify: {
            title: 'Enter code',
            msg: 'Please enter code to redeem {0} planktons to get this reward',
            verify_code: {
                name: '',
                placeholder: 'Enter code here',
                required: '',
                too_short: '',
                invalid: 'Code invalid. Please check the code again',
                use_expire: 'This code has Used/Expired code'
            },
            btn_confirm: 'Confirm'
        }
    },
    history: {
        point: 'planktons',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',
        date_get_point: 'Planktons received date : ',
        date_use_point: 'Planktons used date : ',
        title_earn: 'Earn planktons',

        parcel_number: 'Tracking number : ',
        copy: 'Copy',

        monthPicker: {
            name: '',
            placeholder: '',
            required: 'Please select month/year',
            too_short: '',
            invalid: '',
            month: {
                name: '',
                placeholder: 'Month',
                required: ' '
            },
            year: {
                name: '',
                placeholder: 'Year',
                required: ' '
            },
        },
        menu: {
            coupon: 'My rewards',
            history_point: 'Plankton history',
            favourite: 'Favorite',
            get_friend: 'Invite friends',
        },
        expire: 'Expired',
        delivery: {
            address: 'Address : ',
            mobile_number: 'Tel : ',
        },
        starbuck: {
            date_valid: 'Valid from Today - 16 June 2023',
            detail: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu. Curabitur pellentesque nibh nibh, at maximus ante fermentum sit amet. Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut.',
            btn_back: 'BACK',
            condition: '**  Can be used to purchase any product at Starbucks Coffee stores in Thailand.<br /> *** Cannot be used to reload or activate Starbucks Cards and customers will not get My Starbucks Rewards benefits. No refund. No cash exchange. Cannot be copied or duplicated. Stabucks Coffee (Thiland) Co.,Ltd. reserves the right to make any change to the terms and conditions without prior notice.',
            title: 'e-Coupon',
            price: 'Value {0} Baht',
            remark: '*for purchasing any product.',
        },
        mission: {
            fgf_invite: 'Invited',
            fgf_invite_unit: 'friends',
            fgf_view_history: 'History',
            fgf_code: 'Referral code',
        }
    },
    menubar: {
        home: 'Rewards',
        mission: 'Mission',
        my: 'Me',
    },
    not_found: 'Search not found',
    no_data: 'No data',
    loading: 'Loading. Please wait',
    no_internet: 'Please check your internet connection and try again later.<br>The system is temporarily unavailable. We apologize for any inconvenience caused.',
    modal: {
        register: {
            title: 'Registration successful',
            msg: 'Referral code received',
        },
        redeemed: {
            title: 'Redemption successful',
            msg: 'ยินดีด้วยคุณได้รับสิทธิ์ Viu ดูหนังฟรี 1 เดือน',
            btn: 'OK',
        },
        point: {
            title: 'Redemption successful',
            title_fgf: 'Code entered successfully',
            msg: "Yay! You've got {0} planktons",
        },
        getfriend: {
            title: 'ยินดีด้วย',
            msg: 'คุณได้รับ {0} แพลงก์ตอนจากการกรอกรหัส<br>สำหรับแนะนำเพื่อนตกลง',
        },
        err_code: {
            title: 'Code invalid',
            msg: 'Please check the code again',
        },
        btn: 'OK'
    },
    token_expire: {
        title: 'Please try again later',
        msg: 'Please try again later',
        btn: 'Close',
    },
    page_not_found: 'Page not found',
    under_construction: 'The system is temporarily unavailable.<br>We apologize for any inconvenience caused.',
    coming_soon: 'Coming soon',
    getfriend: {
        title: 'History',
        item_msg: 'You have referred',
        unit_count: 'friend',
        no_data: "You haven't invited any friends this month",
    },
    golden_question: {
        welcome: {
            title: 'คุณเป็นนากช่างสงสัย<br>เหมียวนักผจญภัย<br>หรือเพนกวินรักสงบ',
            message: 'ใช้เวลาเพียง 2 นาที<br>ในการทำแบบทดสอบเพื่อหาตัวตนของคุณ',
            start: 'เริ่มเลย',
            exit: 'ออก',
        },
        question: {
            header: 'ลองดูซิว่าเจ้าตัวไหนที่ตรงกับตัวคุณ',
            from: 'จาก',
            description: 'คุณเห็นด้วยกับข้อความนี้แค่ไหน โปรดระบุคะแนน',
            strongly_disagree: '1 - ไม่เห็นด้วยอย่างยิ่ง',
            strongly_agree: '7 - เห็นด้วยอย่างยิ่ง',
            back: 'ย้อนกลับ',
            next: 'ถัดไป',
            result: 'ดูผล'
        },
        result: {
            you_are: 'คุณคือ',
            animal: {
                otter: 'นากช่างสงสัย',
                cat: 'เหมียวนักผจญภัย',
                corgi: 'คอร์กี้จอมมุ่งมั่น',
                tiger: 'เสือจอมวางแผน',
                bee: 'ผึ้งจอมอึด',
                penguin: 'เพนกวินรักสงบ'
            },
            you_are_in_group: 'คุณอยู่ในกลุ่มนี้',
            see_plankton: 'ได้รับ 50 แพลงก์ตอนแล้ว ดูเลย',
            you_get_plankton: 'ได้รับแพลงก์ตอนแล้ว'
        }
    }
};
